<!--
 * @Author: hzm
 * @Date: 2022-12-16 09:40:55
 * @Description: 
-->
<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item
      :to="index == breadCrumbList.length - 1 ? undefined : item"
      v-for="(item, index) in breadCrumbList"
      :key="item.name"
      >{{ item.meta.title }}</el-breadcrumb-item
    >

    <!-- <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item>
                  <el-breadcrumb-item>活动列表</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ breadCrumbList }}</el-breadcrumb-item> -->
  </el-breadcrumb>
</template>

<script setup lang="ts">
import { headBreadcrumbMatched } from '@/composables/breadCrumb';
const { proxy } = getCurrentInstance();

// console.log(proxy.$router.match);
const breadCrumbList = computed(() => {
  return headBreadcrumbMatched(proxy.$route.matched);
});

watch(
  () => breadCrumbList.value,
  (newValue, oldValue) => {
    console.log('breadCrumbList.value: ', breadCrumbList.value);
  },
  {
    immediate: true,
  }
);
</script>

<style scoped></style>
